(() => {
  const section = document.querySelector('[data-ot-section]');
  if (!section) return;

  const endpoint = section.dataset.otEndpoint;
  const formWrap = section.querySelector('[data-ot-form]');
  const accountWrap = section.querySelector('[data-ot-account]');
  const resultsWrap = section.querySelector('[data-ot-results]');
  const resultsHtml = section.querySelector('[data-ot-results-html]');
  const fallbackWrap = section.querySelector('[data-ot-fallback]');
  const lookupForm = section.querySelector('[data-ot-lookup-form]');
  const errorEl = section.querySelector('[data-ot-error]');
  const submitBtn = lookupForm.querySelector('[type=submit]');
  const resetBtns = section.querySelectorAll('[data-ot-reset]');
  const strings = window.__otStrings || {};

  const showFallback = () => {
    formWrap.hidden = true;
    accountWrap.hidden = true;
    fallbackWrap.hidden = false;
  };

  const resetAll = () => {
    resultsWrap.hidden = true;
    accountWrap.hidden = false;
    fallbackWrap.hidden = true;
    formWrap.hidden = false;
    errorEl.hidden = true;
    resultsHtml.innerHTML = '';
  };

  resetBtns.forEach((btn) => btn.addEventListener('click', resetAll));

  lookupForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;

    const orderNumber = lookupForm.querySelector('[name=order_number]').value.trim();
    const email = lookupForm.querySelector('[name=email]').value.trim();

    submitBtn.disabled = true;
    submitBtn.textContent = strings.loading;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: orderNumber, email }),
      });
      const data = await res.json();
      if (!res.ok || data.error) {
        showFallback();
      } else {
        resultsHtml.innerHTML = data.html;
        formWrap.hidden = true;
        accountWrap.hidden = true;
        resultsWrap.hidden = false;
      }
    } catch {
      showFallback();
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.dataset.label || '';
    }
  });
})();
